(() => {
  const getChatRoots = () => {
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    const runtime = root?.querySelector('shopify-agent-runtime')?.shadowRoot;
    return [root, runtime].filter(Boolean);
  };

  const getLaunchers = () => {
    const wishlistHost = document.querySelector('.gw-widget-placeholder-RC > [data-order]');
    return {
      chat: getChatRoots()
        .map(root => root.querySelector('button[part="activator"]'))
        .find(Boolean),
      loyalty: document.querySelector('#bon-loyalty-btn'),
      wishlist: wishlistHost?.shadowRoot?.querySelector('button.gw-launcher'),
      line: document.querySelector('#oc-plugin-line-icon a')
    };
  };

  const sync = () => {
    const launchers = getLaunchers();
    for (const [name, launcher] of Object.entries(launchers)) {
      document.body.classList.toggle(`hk-tool-ready-${name}`, Boolean(launcher));
      document.querySelectorAll(`[data-hk-tool="${name}"]`).forEach(button => {
        button.hidden = name === 'chat' ? false : !launcher;
      });
    }
  };

  const closeMenu = element => {
    element.closest('header-drawer')
      ?.querySelector('.menu-drawer__close-button')?.click();
  };

  const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
  let chatPending = false;

  document.addEventListener('click', async event => {
    if (!(event.target instanceof Element)) return;

    const contact = event.target.closest('[data-hk-tool="chat"]');
    if (contact) {
      event.preventDefault();
      if (chatPending) return;

      chatPending = true;
      contact.setAttribute('aria-busy', 'true');
      closeMenu(contact);

      try {
        // メニューの閉じる処理を先に完了させます。
        await wait(350);
        let launcher = getLaunchers().chat;

        for (let attempt = 0; !launcher && attempt < 20; attempt++) {
          await wait(500);
          launcher = getLaunchers().chat;
        }

        if (!launcher) {
          window.alert('チャットを読み込めませんでした。ページを再読み込みしてから、もう一度お試しください。');
          return;
        }

        // 開いている場合は、再クリックで閉じないようにします。
        if (launcher.getAttribute('aria-expanded') !== 'true') {
          launcher.click();
        }

        // 開閉アニメーション中の連打を防ぎます。
        await wait(1000);
      } catch (error) {
        console.warn('HeartKey: チャットの起動を確認してください。', error);
      } finally {
        contact.removeAttribute('aria-busy');
        chatPending = false;
      }
      return;
    }

    const button = event.target.closest('button[data-hk-tool]');
    if (!button) return;
    const launcher = getLaunchers()[button.dataset.hkTool];
    if (launcher) {
      closeMenu(button);
      launcher.click();
    }
  });

  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      sync();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  let attempts = 0;
  const timer = setInterval(() => {
    sync();
    if (++attempts >= 20) clearInterval(timer);
  }, 500);
  sync();
})();